import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import { ROUTES } from './routePaths'
import KioskHomePage from '../pages/KioskHome/KioskHomePage'
import SubmitTicketPage from '../pages/SubmitTicket/SubmitTicketPage'
import EventsPage from '../pages/Events/EventsPage'
import DirectoryPage from '../pages/Directory/DirectoryPage'
import SupportUsPage from '../pages/SupportUs/SupportUsPage'
import ResourcesPage from '../pages/Resources/ResourcesPage'

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.HOME} element={<KioskHomePage />} />
        <Route path={ROUTES.SUBMIT} element={<SubmitTicketPage />} />
        <Route path={ROUTES.EVENTS} element={<EventsPage />} />
        <Route path={ROUTES.DIRECTORY} element={<DirectoryPage />} />
        <Route path={ROUTES.SUPPORT_US} element={<SupportUsPage />} />
        <Route path={ROUTES.RESOURCES} element={<ResourcesPage />} />
        <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
      </Routes>
    </BrowserRouter>
  )
}
